import { LibraryPage } from './LibraryPage'
import { TrashSection } from './reviewSections'

/**
 * Egnyte Inbox (Huanrui, 2026-10-08)
 * -------------------------------------------------------------
 * Design work brought in from Egnyte lands here, out of everyone else's
 * sight, tagged with the Project Name and Type its folders gave it. The page
 * is Design Works' page, with only Client and Project Name as filters (Type
 * is Auto Filter's once they are in Design Works: the folders mix sketches
 * and renders); picked pictures can be given a client (ClientBar: their
 * project letters are remembered for it), sent to Design Works with both, or
 * deleted to the trash (SelectionTray). Administrators only (App.tsx, the
 * skill's admin_only).
 *
 * What was deleted from here can be restored for 30 days, in the fold above.
 */
export function EgnytePage() {
  return (
    <>
      <div className="web-egnyte-trash">
        <TrashSection library="egnyte" label="Deleted from the Inbox" />
      </div>
      <LibraryPage key="egnyte" library="egnyte" />
    </>
  )
}
